import { PersonalizationClient } from "@foundation/intercom-client";

const personalizationClient = PersonalizationClient.init({
  host:
    process.env.NEXT_PUBLIC_PERSONALIZATION_CLIENT_URL ||
    "https://personalization.bloomberg.com",
  environment: process.env.NEXT_PUBLIC_COLOR_ENV || "staging",
});

export { personalizationClient };
